/**
 * @Description
 */

/**
 * @description 创建人自选分支节点
 */
export interface SelectNodeList {
  name: string;
  nodeCode: string;
}

/**
 * @description 创建人自选审批人节点
 */
export interface SelectOperatorNodeList {
  name: string;
  nodeCode: string;
}

export interface ApprovalCreateConfig {
  selectNodeList: SelectNodeList[];
  selectOperatorNodeList: SelectOperatorNodeList[];
}

export const demoConfig: ApprovalCreateConfig = {
  selectNodeList: [
    { name: '结点1-1', nodeCode: 'node1-1' },
    { name: '结点1-2', nodeCode: 'node1-2' },
  ],
  selectOperatorNodeList: [
    { name: '结点2', nodeCode: 'node2' },
    { name: '结点3', nodeCode: 'node3' },
  ]
};

/**
 * @description 提交审批的额外参数
 * @param values 表单数据
 * @return
 *  从表单中提取：选择后续结点的审批人、选择分支
 * {
      "nextNodeCode": "node1-2",
       "nodeOperators": [
        {
            "nodeCode": "node2",
            "employeeIds": [
                221548
            ]
        },
        {
            "nodeCode": "node3",
            "employeeIds": [
                220129,
                220247
            ]
        }
      ]
    }
 */
export const dealApprovalSumitExtras = (values: any) => {
  const { nodeOperators: nodeOperatorsVal, nextNodeCode } = values;
  // console.log('dealSumitExtras', values);
  let extras: any = {};
  if (nextNodeCode) {
    extras = {
      ...extras,
      nextNodeCode
    };
  }
  if (typeof nodeOperatorsVal === 'object' && Object.keys(nodeOperatorsVal).length) {
    const keys = Object.keys(nodeOperatorsVal);
    const nodeOperators: any[] = [];
    keys.forEach((key: string) => {
      const val = nodeOperatorsVal[key];
      nodeOperators.push({
        nodeCode: key,
        employeeIds: val,
      });
    });
    extras = {
      ...extras,
      nodeOperators
    };
  }
  return extras;
};

